export default __webpack_public_path__ + "static/media/block-black.31bb8c8c.svg";